import { Alert, type AlertProps } from '@sr/ui-library';
import { userService } from '../../../reducers/permissions/userSlice';
import { useAppDispatch, useTypedSelector } from '../../../stateStore';

/**
 * Alert for Terms and Conditions
 */
export const AlertTermsConditions = ({ ...props }: AlertProps) => {
  const dispatch = useAppDispatch();
  const currentUser = useTypedSelector(userService.selectors.userMe);
  const showAlert = !currentUser?.privacyPolicyDate;

  const handleAcknowledgeClick = async () => {
    await dispatch(
      userService.updateMe({
        firstName: currentUser?.firstName as string,
        lastName: currentUser?.lastName as string,
        privacyPolicyDate: new Date().toISOString(),
      }),
    );

    await dispatch(userService.findMe());
  };

  if (!showAlert) return null;

  return (
    <Alert
      actionButtonProps={{
        children: 'Acknowledge',
        onClick: handleAcknowledgeClick,
      }}
      hasActionButton
      variant="info"
      {...props}
    >
      We&apos;ve moved offices so Screenrights&apos; Privacy Policy has been
      updated to show our new address. You can review the Privacy Policy{' '}
      <a
        href="https://www.screenrights.org/privacy-policy"
        rel="noopener noreferrer"
        target="_blank"
      >
        <strong>here</strong>
      </a>
      . By clicking &apos;Acknowledge&apos;, you confirm that you accept this
      change.
    </Alert>
  );
};
